import React from 'react';
import AuthenticatedPage from "../ContextAndHOC/AuthenticatedPage";
import { withStyles, Button, withWidth } from '@material-ui/core';
import PropTypes from 'prop-types';
import ErrorDialogsuccess from '../components/ErrorDialog';
import SuccessDialog from '../components/SuccessDialog';
import JsonPreview from "./JsonPreview";
import CircularProgress from '@material-ui/core/CircularProgress';
import CommonDashboard from '../components/CommonDashBord';
import {StatusCodes} from 'http-status-codes';
import Title from '../components/CommonDashboardTitle';
import {buildData, handleError} from "../components/DeleteRecurring";
const styles = theme => ({
    root: {marginTop: theme.spacing(3),...theme.mixins.gutters(),paddingTop: theme.spacing(1),paddingBottom: theme.spacing(1),},
    tableStyle: {maxWidth: "1200px", margin: '0px auto', padding: "0",[theme.breakpoints.down("sm")]: {margin: 0 }},
    primaryBtn: { color: theme.palette.text.textPrimaryColor, backgroundColor: theme.palette.primary.main, border: `1px solid${theme.palette.border.primaryBorder}`,
    borderRadius: "50px", margin: "8px 0", textAlign: "right", padding: "7px 20px", textTransform: "uppercase", '&:hover': { backgroundColor: theme.palette.hoverPrimaryColor.main,
    color: theme.palette.text.hoverTextPrimaryColor, border: `1px solid ${theme.palette.border.hoverPrimaryBorder}`, } },
    loadingBody:{minHeight:'100vh'},
});

class ArticleList extends React.Component {
    state = {
         articles:[] ,
        inactivate: false,
        patientId: '',
        totalPatients: '',
        notInactivated: false,
        currentUser:null,
        physicianData: [{userid: 2058},{userid: 2058}],
        loading: true,
        nophysician: false,
        addPhysician: false,
        PatientListCount: 0,
        handlePatientDialogue:true,
        status:null,
        isInactivatePatient: false,
        successMessage: '',
        isUpdateExitDetails: false,
        isDeletePatient: false,
        deletePatientId:'',
        deletedStatus:false,
        patientFilter:"1",
        filterPatientList:null,
        reqAttentionCount:0,
        reqAttentionFilter:"1",
        questionnaireCount:0,
        isAeReportDialogue:false,
        patientName:"",
        Open:false,
        id:0,
        openpopup:false,
        previewopen:true,
        values:{},
        subtype:'',
        title:null,
        dialogueLoad: false,
        deleteDialogStatus:false,
        deleteMessage:"",
        version:null
    };
    ARTICLE_PATH = "./Article/Edit";
    handleEditUser = (resourceid, variant,version, clone,newversion_clone) => {
        const selectedarticle = this.state.articles.filter((n) => n.resourceid === resourceid);
        const versioneditdata =selectedarticle.filter((n) =>n.versionNumber === version);
    if(!clone){
      this.props.history.push({
          pathname: `./Article/Edit/${resourceid}/${variant}`,
          clone,newversion_clone,
          state: { detail:versioneditdata }
        });
  } else {
      this.props.history.push({
          pathname: `./Article/Edit/Clone/${resourceid}/${variant}`,
          clone,newversion_clone,
          state: { detail:versioneditdata }
        });
  }
  };
    handledeletepopup=(resourceid, version)=>{
  this.setState({Open:true,id:resourceid, version});
};
  handleDeleteUser = async () => {
    this.setState({dialogueLoad:true, Open:false})
    let response = await this.props.authenticatedApiCall('post', '/api/content/contentservice/deleteArticleResource', buildData(this.state.articles, this.state.id, this.state.version));
    this.setState({dialogueLoad:false, deleteDialogStatus:true})
    const ErrorMsg = handleError(response);
    this.setState({deleteMessage: ErrorMsg});
  };

   handlepopup = () => {
    this.props.history.push("./CategoryList");
  };
 handleAddvideo=()=>{
this.props.history.push({
        pathname:"./Article/Video",
        state:"video"
        //search: "?id=" +"video"
    });
};
  handlearticlepreview = (resourceid,version) => {
    const selectedarticle = this.state.articles.filter((n) => n.resourceid === resourceid);
    const articlepreviewdata=selectedarticle.filter((n) =>n.versionNumber === version);
    articlepreviewdata.map((val) => {
      this.setState({ values: val.content, subtype: val.subtype, title:val.title, openpopup: true, previewopen: true });
    });
  };
 handleClose = () => {
     this.setState({openpopup:false,previewopen:false});
  };
 handleCloseDialog = () => {
     this.setState({Open:false});
  };
    async componentDidMount() {
        let response = await this.props.authenticatedApiCall('get', '/api/content/contentservice/getArticleResource', null);
        if (response && response.status ===StatusCodes.OK) {
            this.setState({totalPatients:response.data.data.length,PatientListCount:response.data.length});
            this.setState({ articles:response.data.data});
        } else {
            this.setState({articles: []});
        }
    }

   handleAddNewArticle = () => {
      this.props.history.push("./Article/New");
    };
    handleDeleteDialogClose = () => {
      this.props.history.go(0);
    }
    render() {
        const { classes} = this.props;
            let okbutton = [
      <Button className={classes.primaryBtn} onClick={this.handleCloseDialog} >No</Button>,
      <Button className={classes.primaryBtn} onClick={this.handleDeleteUser}>Yes</Button>
    ];
    const deleteDialogButton = [ <Button className={classes.primaryBtn} onClick={this.handleDeleteDialogClose}>Close</Button> ];
    let errorMessage = "Are you sure you want to delete this Article?";
        return (
          <div>
            <div className={classes.tableStyle}>
              <Title titlename={'Article'} count={this.state.totalPatients} button1={this.handlepopup} button2={this.handleAddvideo} button3={this.handleAddNewArticle} />
              {(this.state.totalPatients === "" && this.state.loading) && <div className={classes.loadingBody}>
                <CircularProgress color="primary" style={{ position: "absolute", left: "50%", top: "50%" }} /></div>}
              {this.state.articles && this.state.articles.length > 0 ? <CommonDashboard patientList={this.state.articles} reqAttentionFilter={this.state.reqAttentionFilter}
                handleEditUser={this.handleEditUser} handleDeleteUser={this.handledeletepopup} handleAddNewPatient={this.handleAddNewArticle} name={"article"} handlepreview={this.handlearticlepreview} /> : ""}
            </div>
            {this.state.Open ? <ErrorDialogsuccess successButton={okbutton} HeaderText={errorMessage} dismiss={this.handleCloseDialog} /> : ""}
            {this.state.deleteDialogStatus && <SuccessDialog successButton={deleteDialogButton} HeaderText={"Success"} BodyText={this.state.deleteMessage}  dismiss={this.handleDeleteDialogClose}/>}
            {this.state.dialogueLoad && <div className={classes.loadingBody}> <CircularProgress color="primary" style={{position: "absolute",left: "50%",top:"75%"}}/></div>}
            {this.state.openpopup ? (<JsonPreview open={this.state.previewopen} handleClose={this.handleClose} list={this.state.values}
              title={this.state.title} locationsearch={this.state.subtype} videoform={this.state.subtype} data={false} edit={true} />) : ("")}
          </div>
        );
    }
}
ArticleList.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withWidth()((withStyles(styles)(AuthenticatedPage()(ArticleList))));